<div class="nsc-spacer nsc-spacer--{{ size }}" [class.nsc-spacer--horizontal]="horizontal"></div>
